import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/data/company";

const H = ({ children }) => (
  <h2 className="font-display text-2xl font-bold text-slate-900 mt-10 mb-3">{children}</h2>
);

const TermsConditions = () => {
  return (
    <LegalLayout title="Termeni și condiții" lastUpdated={COMPANY.legalLastUpdated}>
      <p className="text-slate-700">
        Prezentul document stabilește termenii și condițiile de utilizare a site-ului{" "}
        <strong>{COMPANY.website}</strong>, operat de <strong>{COMPANY.legalName}</strong>{" "}
        (CUI: {COMPANY.cui}). Prin accesarea site-ului accepți acești termeni în
        întregime. Dacă nu ești de acord, te rugăm să nu utilizezi site-ul.
      </p>

      <H>1. Date de identificare ale operatorului</H>
      <ul className="list-disc pl-6 space-y-2 text-slate-700">
        <li><strong>Denumire:</strong> {COMPANY.legalName}</li>
        <li><strong>CUI:</strong> {COMPANY.cui}</li>
        <li><strong>Nr. Reg. Comerțului:</strong> {COMPANY.regCom}</li>
        <li><strong>Sediu social:</strong> {COMPANY.address}, {COMPANY.city}, {COMPANY.country}</li>
        <li><strong>Email:</strong> {COMPANY.email}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
      </ul>

      <H>2. Scopul site-ului</H>
      <p>
        Site-ul {COMPANY.website} este un site de prezentare a serviciilor de marketing
        digital oferite de C2 Advertising (Google Ads și Social Media Marketing).
        Nu se desfășoară activități de comerț electronic direct prin site — orice
        colaborare se realizează printr-un contract de prestări servicii încheiat
        separat între părți.
      </p>

      <H>3. Proprietate intelectuală</H>
      <p>
        Tot conținutul site-ului — texte, imagini, logo, grafică, design, cod sursă —
        este proprietatea exclusivă a {COMPANY.legalName} sau a partenerilor și este
        protejat de legislația privind drepturile de autor. Este interzisă copierea,
        reproducerea, distribuirea sau utilizarea conținutului în scop comercial fără
        acordul scris al titularului.
      </p>
      <p>
        Logo-urile clienților afișate pe site sunt proprietatea respectivelor companii
        și sunt folosite cu acordul lor sau în scop de portofoliu, conform practicilor
        comerciale standard în industrie.
      </p>

      <H>4. Utilizarea formularului de contact</H>
      <p>
        Prin completarea și trimiterea formularului de contact, declari că:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-slate-700">
        <li>Informațiile furnizate sunt reale și exacte.</li>
        <li>Ai cel puțin 18 ani sau acționezi în numele unei persoane juridice.</li>
        <li>Ești de acord să fii contactat în legătură cu cererea ta.</li>
      </ul>

      <H>5. Limitarea răspunderii</H>
      <p>
        Conținutul site-ului are caracter informativ. Depunem toate eforturile pentru
        ca informațiile prezentate să fie corecte și actualizate, însă nu garantăm că
        sunt complete sau lipsite de erori. {COMPANY.legalName} nu este responsabilă
        pentru eventuale prejudicii rezultate din utilizarea site-ului sau a
        informațiilor de pe site.
      </p>
      <p>
        Cifrele și exemplele prezentate (ROAS, CPA, statistici) sunt ilustrative,
        bazate pe medii istorice ale campaniilor noastre, și nu reprezintă o garanție
        a rezultatelor pentru clienți noi. Rezultatele depind de industrie, buget,
        produs și piață.
      </p>

      <H>6. Link-uri către site-uri terțe</H>
      <p>
        Site-ul poate conține link-uri către alte site-uri (ex: site-urile
        clienților, platforme partenere). Nu suntem responsabili pentru conținutul
        sau practicile de confidențialitate ale acestor site-uri.
      </p>

      <H>7. Modificări</H>
      <p>
        Ne rezervăm dreptul de a modifica acești termeni oricând. Modificările intră
        în vigoare la momentul publicării lor pe site, cu data ultimei actualizări
        afișată în partea de sus a documentului.
      </p>

      <H>8. Legea aplicabilă și jurisdicție</H>
      <p>
        Acești termeni sunt guvernați de legea română. Orice litigiu va fi soluționat
        pe cale amiabilă; în caz contrar, competența aparține instanțelor judecătorești
        române de la sediul {COMPANY.legalName}.
      </p>

      <H>9. ANPC – Soluționarea alternativă a litigiilor</H>
      <p>
        În cazul în care ești consumator persoană fizică și ai o reclamație, te poți
        adresa Autorității Naționale pentru Protecția Consumatorilor (ANPC) —{" "}
        <a
          href="https://anpc.ro"
          target="_blank"
          rel="noopener noreferrer"
          className="text-magenta hover:underline"
        >
          anpc.ro
        </a>
        {" "}sau platformei europene SOL —{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-magenta hover:underline"
        >
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <H>10. Contact</H>
      <p>
        Orice întrebare legată de acești termeni poate fi adresată la{" "}
        <a
          href={`mailto:${COMPANY.email}`}
          className="text-magenta hover:underline font-semibold"
        >
          {COMPANY.email}
        </a>
        .
      </p>
    </LegalLayout>
  );
};

export default TermsConditions;
